import { useCallback, useMemo } from 'react';

import { IUseQueryProps } from 'store/queries/types';
import { getQueryParams } from 'store/utils/getQueryParams';
import { useAppSelector } from 'store/useAppSelector';

import {
  IFetchProjectsWhitelistsBlockchainsParams,
  selectProjectsWhitelistsBlockchains,
  selectProjectsWhitelistsBlockchainsLoading,
  selectProjectsWhitelistsBlockchainsState,
  useFetchProjectsWhitelistsBlockchainsQuery,
  useLazyFetchProjectsWhitelistsBlockchainsQuery,
} from '../actions/fetchProjectsWhitelistsBlockchains';

export interface IUseProjectsWhitelistsBlockchainsProps
  extends IFetchProjectsWhitelistsBlockchainsParams,
    IUseQueryProps {}

export const useProjectsWhitelistsBlockchains = ({
  group,
  projects,
  skipFetching,
}: IUseProjectsWhitelistsBlockchainsProps) => {
  const params = useMemo(
    (): IFetchProjectsWhitelistsBlockchainsParams => ({ group, projects }),
    [group, projects],
  );

  useFetchProjectsWhitelistsBlockchainsQuery(
    getQueryParams({ params, skipFetching }),
  );

  const [fetchLazy] = useLazyFetchProjectsWhitelistsBlockchainsQuery();

  const handleFetchProjectsWhitelistsBlockchains = useCallback(
    () => fetchLazy(params),
    [fetchLazy, params],
  );

  const projectsWhitelistsBlockchains = useAppSelector(state =>
    selectProjectsWhitelistsBlockchains(state, params),
  );
  const loading = useAppSelector(state =>
    selectProjectsWhitelistsBlockchainsLoading(state, params),
  );
  const state = useAppSelector(storeState =>
    selectProjectsWhitelistsBlockchainsState(storeState, params),
  );

  return {
    handleFetchProjectsWhitelistsBlockchains,
    loading,
    projectsWhitelistsBlockchains,
    state,
  };
};
